import { Button, Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { HasPermission } from '../../authorization/components/HasPermission';
import { AppPermissions } from '../../authorization/Permissions';
import { DynamicUiModel } from '../../common/stores/DynamicUiModel';
import DuplicateClaimsNotification from './DuplicateClaimsNotification';
import SessionInfoLabel from './SessionInfoLabel/SessionInfoLabel';

type Props = {
    appName: string;
    packageName: string;
    ui: DynamicUiModel;
    onReload?: () => void;
    setSettingsDialogVisible: (value: boolean) => void;
    handleClick: (id: string) => void;
    dataId?: string;
    formId?: string;
    sessionState?: string;
    restricedModeEnabled?: boolean;
};

const DocumentHeaderRenderer: React.FC<Props> = ({
    appName,
    packageName,
    ui,
    onReload,
    setSettingsDialogVisible,
    sessionState,
    handleClick,
    dataId,
    formId,
    restricedModeEnabled
}) => {
    return (
        <div className="alpha-form-title-container">
            <div className="alpha-form-title-inner-container">
                <div className="app-form-info">
                    <span className="app-name">{appName}</span>
                    <h3>{packageName}</h3>
                </div>

                <DuplicateClaimsNotification duplicateClaims={ui.layoutConfiguration?.duplicateClaims} />

                {ui.actions && ui.actions.length ? (
                    <div className="app-form-controls">
                        <SessionInfoLabel infoText={ui.additionalInfo} placement="bottom" />
                        {!restricedModeEnabled && onReload ? (
                            <HasPermission permissionClaim={AppPermissions.CanManageSessionsAndDocuments}>
                                <Tooltip title="Reload">
                                    <Button
                                        type="link"
                                        className="reload-button"
                                        onClick={onReload}
                                        data-id={`alpha-application-form-reload-left-${dataId ? dataId : 'undefined'}`}
                                    >
                                        <i className="alpha-icon reload xs" />
                                    </Button>
                                </Tooltip>
                            </HasPermission>
                        ) : null}

                        <Tooltip title="Settings">
                            <Button
                                type="link"
                                className="reload-button"
                                onClick={() => setSettingsDialogVisible(true)}
                                data-id={`alpha-application-form-blocks-left-${dataId ? dataId : 'undefined'}`}
                                style={{ marginTop: -8 }}
                            >
                                <i className="alpha-icon gear-gray" style={{ width: 24, height: 24 }} />
                            </Button>
                        </Tooltip>

                        {sessionState !== 'Archived' && (
                            <HasPermission permissionClaim={AppPermissions.CanManageSessionsAndDocuments}>
                                <Button
                                    key={0}
                                    className="submit-button"
                                    name={'submitButton'}
                                    htmlType="submit"
                                    form={formId}
                                    type="primary"
                                    data-id={`alpha-application-form-submit-left-${dataId ? dataId : 'undefined'}`}
                                    onClick={() => handleClick(ui.actions[0].id)}
                                    disabled={ui.actions[0].isDisabled}
                                >
                                    {ui.actions[0].name}
                                </Button>
                            </HasPermission>
                        )}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default observer(DocumentHeaderRenderer);
